var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-prototype-builtins */
import { BigNumber } from "bignumber.js";
import { Subject } from "rxjs";
import { log } from "@ledgerhq/logs";
import { PRELOAD_MAX_AGE } from "./logic";
import { getRegistry, getMinimumBondBalance } from "./cache";
import { getStakingProgress, getValidators } from "./validators";
import { loadPolkadotCrypto } from "./polkadot-crypto";
var currentPolkadotPreloadedData = {
    validators: [],
    staking: undefined,
    minimumBondBalance: "0"
};
function fromHydrateValidator(validatorRaw) {
    return {
        address: validatorRaw.address,
        identity: validatorRaw.identity,
        nominatorsCount: Number(validatorRaw.nominatorsCount),
        rewardPoints: validatorRaw.rewardPoints === null
            ? null
            : new BigNumber(validatorRaw.rewardPoints),
        commission: new BigNumber(validatorRaw.commission),
        totalBonded: new BigNumber(validatorRaw.totalBonded),
        selfBonded: new BigNumber(validatorRaw.selfBonded),
        isElected: !!validatorRaw.isElected,
        isOversubscribed: !!validatorRaw.isOversubscribed
    };
}
function fromHydratePreloadData(data) {
    var validators = [];
    var staking = undefined;
    var minimumBondBalance = "0";
    if (typeof data === "object" && data) {
        if (Array.isArray(data.validators)) {
            validators = data.validators.map(fromHydrateValidator);
        }
        if (data.staking !== null && typeof data.staking === "object") {
            var _a = data.staking, electionClosed = _a.electionClosed, activeEra = _a.activeEra, maxNominatorRewardedPerValidator = _a.maxNominatorRewardedPerValidator, bondingDuration = _a.bondingDuration;
            staking = {
                electionClosed: !!electionClosed,
                activeEra: Number(activeEra),
                maxNominatorRewardedPerValidator: Number(maxNominatorRewardedPerValidator) || 128,
                bondingDuration: Number(bondingDuration) || 28
            };
        }
        if (data.minimumBondBalance !== null &&
            typeof data.minimumBondBalance === "string") {
            minimumBondBalance = data.minimumBondBalance || "0";
        }
    }
    return {
        validators: validators,
        staking: staking,
        minimumBondBalance: minimumBondBalance
    };
}
var updates = new Subject();
export function getCurrentPolkadotPreloadData() {
    return currentPolkadotPreloadedData;
}
export function setPolkadotPreloadData(data) {
    if (data === currentPolkadotPreloadedData)
        return;
    currentPolkadotPreloadedData = data;
    updates.next(data);
}
export function getPolkadotPreloadDataUpdates() {
    return updates.asObservable();
}
/**
 * load max cache time for the validators
 */
export var getPreloadStrategy = function () { return ({
    preloadMaxAge: PRELOAD_MAX_AGE
}); };
var shouldRefreshValidators = function (previousState, currentState) {
    return !previousState || currentState.activeEra !== previousState.activeEra;
};
export var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var minimumBondBalance, minimumBondBalanceStr, currentStakingProgress, previousValidators, previousStakingProgress, validators, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, loadPolkadotCrypto()];
            case 1:
                _a.sent();
                return [4 /*yield*/, getRegistry()];
            case 2:
                _a.sent(); // ensure registry is already in cache.
                return [4 /*yield*/, getMinimumBondBalance()];
            case 3:
                minimumBondBalance = _a.sent();
                minimumBondBalanceStr = minimumBondBalance.toString();
                return [4 /*yield*/, getStakingProgress()];
            case 4:
                currentStakingProgress = _a.sent();
                previousValidators = currentPolkadotPreloadedData.validators, previousStakingProgress = currentPolkadotPreloadedData.staking;
                validators = previousValidators;
                if (!(!validators ||
                    !validators.length ||
                    shouldRefreshValidators(previousStakingProgress, currentStakingProgress))) return [3 /*break*/, 8];
                log("polkadot/preload", "refreshing polkadot validators...");
                _a.label = 5;
            case 5:
                _a.trys.push([5, 7, , 8]);
                return [4 /*yield*/, getValidators("all")];
            case 6:
                validators = _a.sent();
                return [3 /*break*/, 8];
            case 7:
                error_1 = _a.sent();
                log("polkadot/preload", "failed to fetch validators", {
                    error: error_1
                });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/, {
                    validators: validators,
                    staking: currentStakingProgress,
                    minimumBondBalance: minimumBondBalanceStr
                }];
        }
    });
}); };
export var hydrate = function (data) {
    var hydrated = fromHydratePreloadData(data);
    log("polkadot/preload", "hydrate " + hydrated.validators.length + " polkadot validators");
    setPolkadotPreloadData(hydrated);
};
//# sourceMappingURL=preload.js.map